import firebase from '@firebase/app'
import Cookies from 'js-cookie'
import moment from "@/moment-gp";
import store from "@/store"
import $models from "@/models"
import { rem_ready, set_ready, get_registry_state, get_registry } from '@/api/misc'
import { guess_timezone } from '@/models/user/userSettings/util.js'
import {
  auth_logout,
  auth_check_invitation_code,
  auth_activate_user } from '@/api/auth'
import GenericStore from '@/generic_api/lib/generic_store/GenericStore'
import util from '@/util'

import {
  IS_CLOSED_BETA,
  // SIMULATE_SLOW_LOAD,
  // LOAD_GOALS_ON_STARTUP,
  LOAD_TRELLO_ON_STARTUP,
  LOAD_GOOGLE_ON_STARTUP,
  LOAD_QUOTES_ON_STARTUP,
  LOAD_CHALLENGES_ON_STARTUP } from '@/features.js';

const DEFAULT_ROUTER_AFTER_LOGIN = '/today/goals';

const LOAD_ALL_GOALS_ON_OPEN = true;

let num_of_active_goals_while_updateting = 0;
/*
let devGlobalGoalReference = [];
let devGlobalUserGoalReference = [];

if (process.env.NODE_ENV !== "production") {
  window.gpdev.devGlobalGoalReference = devGlobalGoalReference;
  window.gpdev.devGlobalUserGoalReference = devGlobalUserGoalReference;
}
*/

let invitation_automatically_activated = false;

const log1 = (...args) => { console.log('[LOADPROCESS.V2]', ...args) };
const log2 = (...args) => { /* console.log('[LOADPROCESS.V2*]', ...args) */ };

let router = {
  lastRouteRedirect: null,
  currentRoute: { query: {} },
  push( route ) {
    console.warn("No router available, but resource manager wants to change route to", route );
    this.lastRouteRedirect = route;
  }
}

const ResourceLoader = {

  // ---------------------------------------------------------------------------
  connectRouter( vue_router ) {
    var lastRouteRedirect = router.lastRouteRedirect
    console.log("Got real router => lastRouteRedirect", lastRouteRedirect)

    /* After approx 500 ms the router is loaded, so replace fake router with
       real router and redirect to last redirect route passed to the fake router. */
    router = vue_router;

    if ( lastRouteRedirect ) {
      router.push( lastRouteRedirect );
    }
  },
  /*
  _currentRouteName() {
    return router ? router.currentRoute.name : null;
  },
  onRouteChange( from, to ) {
    log2("Navigation detected from", from.path, ">", to.path);
  },
  */

  // ---------------------------------------------------------------------------
  onDatabaseConnect() {
    console.log("[.info/conntected] connected");
    /*
    // If we are currently connected, then use the 'onDisconnect()'
    // method to add a set which will only trigger once this
    // client has disconnected by closing the app,
    // losing internet, or any other means.
    userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function() {
        // The promise returned from .onDisconnect().set() will
        // resolve as soon as the server acknowledges the onDisconnect()
        // request, NOT once we've actually disconnected:
        // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

        // We can now safely set ourselves as 'online' knowing that the
        // server will mark us as offline once we lose connection.
        userStatusDatabaseRef.set(isOnlineForDatabase);
    });
    */
  },

  // ---------------------------------------------------------------------------
  onDatabaseDisconnect() {
    console.log("[.info/conntected] disconnected");
  },

  // ---------------------------------------------------------------------------
  async afterUserSignIn( user ) {

    console.log("afterUserSignIn => login", user);

    store.commit(`user/SET_PROFILE`, user); // TODO replace with mapReady api

    /* Set registry to ready */
    get_registry().commit('INIT_REGISTRY');

    this.attachUser(user.uid); // user/{userid}/private/userdata
    // this.attachContact(user.uid); // user/{userid}/public/status done internally

    if ( !( user.additionalUserInfo && user.additionalUserInfo.isNewUser ) ) {
      /* Update status, but not for new users - display name is not set yet */
      // INFO: Actually only necessary when user uses providerId 'password'
      $models.userStatus.update( $models.userStatus._get_uid(), {
        profilePic:  user.photoURL || null, // ???
        displayName: user.displayName || 'Unknown', // display name is set later, not by auth
        isOnline:    true,
        lastSeen:    firebase.database.ServerValue.TIMESTAMP,
        // email: user.email,
        // device: navigator.userAgent
      })
    } else {
      let displayName = this.displayName || localStorage.getItem('userDisplayName') || 'New user'
      await $models.userStatus.update( $models.userStatus._get_uid(), {
        displayName: displayName,
      })
    }

    $models.userStatus
      .childRef( $models.userStatus._get_uid() )
      .onDisconnect() // Setting up the onDisconnect hook
      .update({ // No client validation
        isOnline: false,
        lastSeen: firebase.database.ServerValue.TIMESTAMP,
        // device: navigator.userAgent
      });

    // TODO: Update any data that might by out of sync (directory?)
    /* HACK: Write user name and email to firebase, so it can be used for user search later.
       Drawback: Only users are found who logged in at least once */

    // INFO: When you establish an onDisconnect() operation, the operation lives on the Firebase Realtime Database server.

    /* We get here when the user got an invitation could, but was not logged in */
    let invitationCode = Cookies.get('invitationCode') || null
    if ( router.currentRoute.query && router.currentRoute.query.code ) {
      invitationCode = router.currentRoute.query.code;
    }

    /*
    if ( check if user is unconfirmed -> custom claim ) {
      // This won't happen (users are deactivate after registration + we already did a logout before refresh?)
    }
    */

    if ( invitationCode ) {

      /* User came here by clicking invitation link in email */
      console.log("Got invitation Code", invitationCode)

      try {

        /* activate_invitation will also set emailVerified to true (on the backend) */
        // auth_activate_invitation({ email, invitationCode })
        await auth_check_invitation_code({
          code: invitationCode,
          email: firebase.auth().currentUser.email // TODO ???
        })

        /* Delete cookie after applying */
        Cookies.remove('invitationCode')

        router.app.$notify.success({
          title: 'Invitation accepted', // TODO bessere formulierung
          message: "Invitation accepted",
        });

        /* Save the fact, that the inviation has already been activated to a variable */
        invitation_automatically_activated = true;

        /* navigate to new resource and remove invitationCode from query (route.redirect) */
        router.push({
          path: router.currentRoute.query.redirect || DEFAULT_ROUTER_AFTER_LOGIN,
          query: {}
        })
        return

      } catch ( error ) {

        if ( error.message === 'wrong-code' ) {

          Cookies.remove('invitationCode')

          if ( IS_CLOSED_BETA ) {

            auth_logout()
            router.push('/todo') // TODO

          } else {

            /* show info that ref code is outdated, but let user use the app */

            router.app.$notify.warning({
              title: 'Warning',
              message: "You're invitation code is outdated or invalid.",
            });

            router.push({
              path: router.currentRoute.query.redirect || DEFAULT_ROUTER_AFTER_LOGIN,
              query: {}
            })
            return
          }
        }

        if ( error.message === 'wrong-account' ) {
          /* Remove the invitation code and show info */
          Cookies.remove('invitationCode')

          router.app.$notify.warning({
            title: 'Warning',
            message: "You opened an invitation link that was meant for another user. " +
                     "Please logout and try again.",
            duration: 0
          });

        }
      }
    }
  },

  // ---------------------------------------------------------------------------
  afterUserSignOut() {

    // TODO: This also gets called, when user is not signed in at all

    console.log("[afterUserSignOut] Logout! Resetting all data.")
    /* INFO: This will also be called when user is not signed in at all */

    // The reason why we store the user status in vuex is that it will
    // allow us to create and use a reactive getter on the user login state
    // TODO: move to app/*
    store.commit("user/LOGOUT", null, { root: true });

    /* Detach all contacts? */
    // this.dettachAllContacts();

    /* Stop system timer */
    store.dispatch('session/session_stop_system_timer');

    /* Clear instance cache */
    $models.userReadonly.reset_global_instance_cache();

    /* Remove all subscriptions */
    for ( var key in $models ) {
      if ( key === '_prototype' ) {
        continue
      }
      let model = $models[ key ]
      let sublist = model.subscriptions

      /* reset models */
      model.reset();

      /* unsubscribe */
      if ( sublist ) {
        Object.keys(sublist).forEach(sub => {
          let callback = sublist[ sub ];
          console.log("Calling unsubscribe for", key, ":", sub);
          callback();
        })
      }
    }

    /* Reset registry */
    get_registry().commit('RESET_REGISTRY');

    // TODO: if we do this we dont need watcher
    // this.dettachAllGoals();

    /* Clear regular Vuex store */
    store.dispatch('clearAll');

    /* Set user id to null */
    GenericStore.defaultUserId = null;

    /* Remove watcher goal list */
    if ( this.goal_watcher ) {
      this.goal_watcher();
    }

    /* Dettach all goals? */
    this.dettachAllGoals(); // TODO: necessary?
  },

  // ---------------------------------------------------------------------------
  // Called before user is registered and before afterUserSignIn is called
  beforeUserRegistration({ userName }) {
    this.displayName = userName
    localStorage.setItem('userDisplayName', userName)
  },

  // ---------------------------------------------------------------------------
  afterUserRegistration({ displayName = null } = {}, isOAuth = false) {
    console.log("After user registration")
    /* For email sign up auth_update_display_name() is already called by auth_signup.
       For O-Auth sign up firebase takes care of it. */
      // User came here by going to goalpilot.com directly

    if ( IS_CLOSED_BETA ) {

      /* Show UI für ref code input. During closed beta we always ask for an invitation code.
         installRouteGuard that blocks all other routes */

      if ( !invitation_automatically_activated ) {
        router.push("/confirm-invitation");
      }

    } else {

      // During open beta users can just register and start using the app. However there
      // invitations are not executed until they confirm their email address.
      // Also we still need an activation / user creation mechanism therefor call activate_user

      auth_activate_user()
    }

    // set status
    if ( displayName ) { // TODO: MAKE SUER defaultUserId is set !!! - worked - maybe skip for sign in with google
      $models.userStatus.update( $models.userStatus._get_uid(), {
        displayName: displayName,
        isOnline: true,
        lastSeen: firebase.database.ServerValue.TIMESTAMP,
      })
    }

    // TODO: Set cookies / local storage to default values?
    /*
          "calendar_view_settings": {
        "view": "agenda",
        "timeslotDuration":"00:15:00",
        "show_now_indicator":true,
        "visible_range":{
          "from_date":"2019-04-10T00:00:00-04:00",
          "to_date":"2019-04-17T00:00:00-04:00",
          "horizon":7
        },
        "visible_time":{
          "min_time":0,
          "max_time":24
        },
        "source":{
          "optimizer":false,
          "user":false,
          "tsc":true,
          "_stacking":true
        }
      }
    */
    /*
    const defaultLocalStorage = {
      dateformat: "LLLL",
      language:   "en",
      timezone:   "America/New_York"
    }
    const defaultCookies = {
      debugtoolStatus:  1,
      sessionbarStatus: 0,
      sidebarStatus:    1,
    }
    */
  },

  // ---------------------------------------------------------------------------
  beforeAppStartsLoading() {

    log2("beforeAppStartsLoading", {
      LOAD_TRELLO_ON_STARTUP,
      LOAD_GOOGLE_ON_STARTUP,
      LOAD_QUOTES_ON_STARTUP,
      LOAD_CHALLENGES_ON_STARTUP
    });

    if ( LOAD_TRELLO_ON_STARTUP ) {
      // TODO: call new stores
      // store.dispatch('goal/trello_onload');
    }

    if ( LOAD_GOOGLE_ON_STARTUP ) {
      // TODO: call new stores
      store.dispatch('calendar/google_calendar_onload');
    }

    if ( LOAD_QUOTES_ON_STARTUP ) {
      // TODO: call new stores
      // store.dispatch('calendar/quotes_onload');
    }

    // store.dispatch('goal/activity_onload');
    // store.dispatch('optimizer/optimizer_onload');

    if ( LOAD_CHALLENGES_ON_STARTUP ) {
      // TODO: call new stores
      // store.dispatch('goal/challenges_onload');
    }

    /* Check if we're comming from a login redirect. Returns { user: null }
       when not redirect from O-Auth provider */
    firebase.auth().getRedirectResult().then((result) => {

      if ( result.user ) {

        if ( result.credential ) {
          /* This gives you a Google Access Token. You can use it to access the Google API. */
        }

        if ( result.additionalUserInfo.isNewUser ) {
          /* We just created a new user via O-Auth sign up */
          this.afterUserRegistration( result.user, true )
        }

        router.push( router.currentRoute.query.redirect || DEFAULT_ROUTER_AFTER_LOGIN )
      }
      /* else {
        router.push( router.currentRoute.query.redirect || DEFAULT_ROUTER_AFTER_LOGIN ) // ???
      } */
    })

    /* TODO
    store.watch(
      () => store.getters['goal/all_goals_are_ready'],
      () => {
        store.dispatch('optimizer/optimizer_trigger', { });
        log2('OPTIMIZER TRIGGERED')
      }
    )

    all_goals_are_ready: (state, getters) => {
      if ( state.stateUpdateCounter === 0 ) {
        // This means we didn't start the loading process yet
        return false;
      }
      return Object.keys(state.goal_list).every(id => {
        return getters.goal_is_ready(id);
      })
    },
    */

    /*
    */
    // // TODO: registry?
    // store.watch(
    //   () => $models.goalMeta.getters.all_goals_loaded, // store.getters['goal/goal_list_ids'], // TODO
    //   (new_goal_list, old_goal_list) => {
    //     this.goalListReady(new_goal_list, old_goal_list);
    //   },
    // )
  },

  // ---------------------------------------------------------------------------
  afterAppStartsLoading() {
    log2("afterAppStartsLoading", {});
  },

  // ---------------------------------------------------------------------------
  installGoalWatcher() {

    console.log("[RL:Watcher:Goal] - Installing...")

    let unwatch = store.watch(
      () => $models.goalMeta.getters.all_goals_user, // store.getters['goal/goal_load_list'],
      ( goal_list_new ) => {

        console.log("[RL:Watcher:Goal] - got goal list", goal_list_new)

        if ( goal_list_new === undefined ) {
          console.log("[RL:Watcher:Goal] -> got undefined")
          return
        }

        let ids_new = Object.keys( goal_list_new )

        let ready_list = get_registry_state().ready
        let ids_old = Object.keys(ready_list)
          .filter(ready_list => ready_list.startsWith('goal:'))
          .map(ready_list => ready_list.slice(5))

        // let ids_old = Object.keys( goal_list_old )

        console.log("[RL:Watcher:Goal] ids", ids_old.length, '-->', ids_new.length)

        if ( ids_new && ids_new.length > 0 ) {
          // .map( item => item.$id )
          // console.log("[RL:Watcher:Goal] CLOUD FUNCTION CREATED GOAL WATCHER", ids_new)

          let diff = util.arrayDiffTwoWay( ids_new, ids_old );
          console.log("[RL:Watcher:Goal] DIFF", diff);

          diff.added.forEach(new_id => {
            // const promises =
            this.attachGoal( new_id, false );
          })

          diff.removed.forEach(rem_id => {
            this.dettachGoal( rem_id )
          })

          // this.attachGoalList(ids_new, false) // TODO: Testen
        }
      },
      // { deep: true }
    )
    this.goal_watcher = unwatch;
  },

  // ---------------------------------------------------------------------------
  afterUserContentCreated( userReadonly ) {
    console.log(">> afterUserContentCreated", userReadonly)

    /*
    let userId = $models.user.defaultUserId;
    console.log(">> userId", userId)

    let userSettings = $models.userSettings.subscribeNode( userId )
    console.log(">> userSettings", userSettings)
    */

    const HARD_RELOAD_AFTER_CONTENT_CREATED = false;

    if ( HARD_RELOAD_AFTER_CONTENT_CREATED ) {

      router.go()
      return Promise.resolve();

    } else {

      // TODO: Does not work yet
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          console.log(">> afterUserContentCreated --- TRIGGER")
          this.userReadonlyReady( userReadonly );
          // this.userSettingsReady( userSettings );
          // this.attachGoalList(ids_new, false)
          resolve();

        }, 3000) // HACK / WORKAROUND
      })

    }
  },

  // ---------------------------------------------------------------------------
  afterAppMounted() {
    log2("afterAppMounted", {});
  },

  // ---------------------------------------------------------------------------
  afterUserReady() {
    log2("afterUserReady", {});

    // start system timer
    store.dispatch('session/session_start_system_timer');
  },

  // ---------------------------------------------------------------------------
  attachUser( authUserId ) {
    log1("attachUser");

    GenericStore.defaultUserId = authUserId;

    let userSettings = $models.userSettings.subscribeNode(authUserId)
    let userReadonly = $models.userReadonly.subscribeNode(authUserId)
    $models.userPublic.subscribeNode(authUserId)
    $models.userTimer.subscribeNode(authUserId)
    $models.userContact.subscribeList()
    // $models.userMsgInbox.with({ uid: authUserId }).subscribeList()

    // Load timeslot collections
    // TODO: fetch would be enough, since only I can change the tsc
    let tscList = $models.timeslotCollection.with({ uid: authUserId }).subscribeList()
    // TODO: Query:
    // TODO: query on timeslotWeekdayPrefs
    // TODO: query on timeslotExceptions
    let tscPrefList = $models.timeslotWeekdayPref.with({ uid: authUserId }).subscribeList()
    let tscExceList = $models.timeslotException.with({ uid: authUserId }).subscribeList()

    Promise.all([
      tscList.$promise,
      tscPrefList.$promise,
      tscExceList.$promise
    ]).then(() => {
      set_ready('timeslot_collections')
    })

    // TODO: UPDATE $models.userdirectory.update( authUserId, {...} )

    this.attachContacts( authUserId )

    userSettings.$promise.then(() => {
      this.userSettingsReady( userSettings );
    })

    userReadonly.$promise.then(() => {
      this.userReadonlyReady( userReadonly );
    })

    Promise.all([ userSettings.$promise, userReadonly.$promise ]).then(() => {
      set_ready('user') // TODO: Check if registry is ready
      store.commit('user/SET_INITIALIZED', null, { root: true }) // TODO: only used here
    })

    set_ready('auth')
  },

  // ---------------------------------------------------------------------------
  /*
   * This is called as soon as the user settings are ready
   */
  userSettingsReady( userSettings ) {

    let initialized = store.getters['user/initialized'] // TODO: only used here
    let loggedIn = store.getters['user/loggedIn']

    if (!initialized && loggedIn) {
      log2("User settings ready", userSettings);

      /* If timezone is not set, auto-guess timezone. If timezone has changed,
         ask user to confirm. This will happen DIRECTLY after user is registered,
         so security rules must allow write at this point. Cloud function will not touch "settings/settings" */
      let new_timezone = guess_timezone();
      let new_language = 'en'; // TODO: guess from browser settings
      let new_dateformat = 'LLLL';
      if ( !userSettings.settings || userSettings.settings.timezone === 'I/DONT/KNOW' ) {
        $models.userSettings.update( $models.user.defaultUserId, {
          'settings/timezone':   new_timezone,
          'settings/language':   new_language,
          'settings/dateformat': new_dateformat,
        })
        localStorage.setItem('timezone', new_timezone);
      } else if ( userSettings.settings.timezone !== new_timezone ) {
        // TODO: This will ask user EVERY time after they log in
        //       Maybe add a special character 'Europe/Berlin!' to
        //       indicate that the users wants to overwrite the default.
        let root = router.app;
        root.$confirm(
          'Update timezone to ' + new_timezone + '?',
          'Timezone change detected', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Keep Timezone'
        })
        .then(() => {
          return $models.userSettings.update( $models.user.defaultUserId, {
            'settings/timezone': new_timezone
          })
        })
        .then(() => {
          localStorage.setItem('timezone', new_timezone);
          root.$message({ type: 'info', message: 'Timezone saved.' });
        })
        .catch(() => {});
      }
    }
  },

  // ---------------------------------------------------------------------------
  /*
   * This is called as soon as the user settings are ready
   */
  userReadonlyReady( userReadonly ) {

    // let initialized = store.getters['user/initialized'] // TODO: only used here
    // let loggedIn = store.getters['user/loggedIn']

    if ( userReadonly.status !== 'active' ) {
      log1("User status is not active -> doing nothing")
      set_ready('goals') // HACK! Otherwise loading screen
      router.push('/confirm-invitation')
      return
    }

    if ( userReadonly ) {

      /* Attach goals and commitments */
      let userGoalSettingsList = $models.userGoalSettings.subscribeList()
      let userCommitmentSettingsList = $models.userCommitmentSettings.subscribeList()
      let userGoalCategoryList = $models.userGoalCategory.subscribeList();

      userGoalSettingsList.$promise.then(() => log2("All user goal settings ready"))
      userCommitmentSettingsList.$promise.then(() => log2("All user commitments settings ready"))
      userGoalCategoryList.$promise.then(() => log2("All user goal categories ready"))

      /* Convert {'a': true, 'b': false, 'c': true} to ['a', 'c'] */
      /*
      let loadGoalList = Object.keys(userdata.goals)
                         .map(k => { return userdata.goals[k] ? k : undefined })
                         .filter(v => v);

      const { promiseGoalMetaList, promiseCommitmentsList, promiseRecordedSessions }
        = this.attachGoalList( loadGoalList, true )
      */

      // TODO: Don't wait !! (Call const promises = this.attachGoal( goal_id, true ); when ready)
      userGoalSettingsList.$promise.then(() => {
        let loadGoalList = userGoalSettingsList.$id_list

        if ( !LOAD_ALL_GOALS_ON_OPEN ) {
          return
        }

        const {
          promiseGoalMetaList,
          promiseCommitmentsList,
          promiseRecordedSessions }
            = this.attachGoalList( loadGoalList, true )

        // TODO: Handle errors when user has no goals

        // Promise.all([...promiseGoalMetaList, userGoalSettingsList.$promise]).then(() => {
        Promise.all(promiseGoalMetaList).then(() => {
          log1("Got ALL goals")
          set_ready('goals') // TODO: THIS IS TRIGGERED ALSO WHEN 0 goals

          /* Install goal watcher */
          this.installGoalWatcher(); // TODO
        });

        Promise.all(promiseCommitmentsList).then(() => {
          log1("Got ALL commitments")
          set_ready('commitments')
        });

        Promise.all(promiseRecordedSessions).then(() => {
          log1("Got ALL recorded sessions")
          set_ready('recorded_sessions')
        });
      })
    }
  },

  // ---------------------------------------------------------------------------
  attachContacts( authUserId ) {
    // first attach myself:
    $models.userStatus.subscribeNode(authUserId)
    /* TODO:
    var contact_list = $$models.userContact.getters.contact_list;
    if (contact_list) {
      //console.log("Nr of Contacts: " + contact_list.length);
      //console.table(contact_list);
    }
    //log.info(" attach contact", id);
    if (contact_list && contact_list.length > 0 && contact_list.includes(id)) {
      //console.log("Contact with id %s is already attached", id);
      return;
    }
    if (id) {
      let contactQuery = db.collection("users/" + id + "/public").doc("status");
      this.contacts[id] = contactQuery;
      store.dispatch("contact/setContactRef", { ref: contactQuery, id: id });
    }
    */
  },

  // ---------------------------------------------------------------------------
  dettachAllContacts() {
  },

  // ---------------------------------------------------------------------------
  /*
   * Attaches a list of goals
   */
  attachGoalList(goal_id_list, is_multi_goal_attach) {
    log2('attaching goal list', goal_id_list, is_multi_goal_attach);

    const promiseGoalMetaList = [];
    const promiseCommitmentsList = [];
    const promiseRecordedSessions = [];

    goal_id_list.forEach(goal_id => {
      const promises = this.attachGoal( goal_id, is_multi_goal_attach );
      if ( promises ) {
        promiseGoalMetaList.push( promises.promiseGoalMeta )
        promiseCommitmentsList.push( promises.promiseCommitments )
        promiseRecordedSessions.push( promises.promiseRecordedSessions )
      }
    });

    // store.commit("goal/INCREASE_UPDATE_COUNT");
    // TODO: store.commit("goal/RESET_GOAL_LOAD_LIST");

    return {
      promiseGoalMetaList,
      promiseCommitmentsList,
      promiseRecordedSessions
    }
  },

  // ---------------------------------------------------------------------------
  /*
   * Attaches one goal (Firestore)
   */
  attachGoal( goal_id, is_multi_goal_attach ) {
    log2("attaching goal", goal_id);

    // let goal_list_state = store.getters['goal/goal_list_state']; // TODO
    let goal_list_state = get_registry_state().res.goal || {}
    // TODO: maybe better: get_registry_state().sync[ '/goal/' + goalId + '/meta' ]

    if ( goal_list_state[goal_id] ) {
      // TODO X1: This does not work, when user leaves goal and then joins again
      if ( is_multi_goal_attach ) {
        log2(`Goal with goal_id ${goal_id} is already attached`);
      }
      return {
        promiseGoalMeta: Promise.resolve(),
        promiseCommitments: Promise.resolve()
      };
    }

    let p1 = $models.goalMeta.subscribeNode( goal_id ).$promise

    /* Only loads my commitments, not commitments I have access to */
    let p2 = $models.commitment.with({ goalId: goal_id }).subscribeList().$promise

    // TODO: who tries to load commitments from other users as my user?

    // load all recorded Sessions
    let startAtTimestamp = (moment.utc().unix() - 1 * 24 * 60 * 60 ).toString()
    // console.log('start at:',startAtTimestamp)
    let p3 = $models.taskRecordedSession
      .with({ goalId: goal_id })
      .subscribeList({ startAt: startAtTimestamp })
      .$promise

    p1.then(() => {
      log2("Got Goal Meta for", goal_id)
      // store.commit("goal/INCREASE_UPDATE_COUNT"); // vorher bei goal user settings
    })

    p2.then(() => {
      log2("Got all Goal Commitments for Goal", goal_id)
    })

    p3.then(() => {
      log2("Got all recorded sessions for Goal", goal_id)
    })

    // TODO: Load tasks (for optimizer)

    /*
    let p2 = $models.task_meta.with({ goalId: goal_id }).sync_list();
    let p4 = $models.commitment.with({ goalId: goal_id }).sync_list();

    let p3 = $models.task_meta.with({ goalId: goal_id, uid : 'TEAM' }).sync_list();
    let p5 = $models.commitment.with({ goalId: goal_id, uid : 'TEAM' }).sync_list();
    let p6 = $models.commitment_session.with({ goalId: goal_id }).sync_list()
    let p7 = $models.commitment_task_end_date.with({ goalId: goal_id }).sync_list()
    */

    // return Promise.all([p1, p2, p3, p4, p5, p6, p7])
    Promise.all([ p1, p2, p3 ]).then(() => {
      log2("ready goal:", goal_id);
      set_ready( 'goal:' + goal_id );
    })

    /* Set ready to false, but indicated that it's loading */
    set_ready( 'goal:' + goal_id, false );

    // todo: attach as list
    /*
    let p3 = $models.userGoalSettings.subscribeList().$promise
    p3.then(() => {
      log2('User Goal attached!', goal_id);
      store.commit("goal/INCREASE_UPDATE_COUNT");
    })
    */

    /*
    devGlobalGoalReference[goal_id] = p1;
    devGlobalUserGoalReference[goal_id] = p3;

    $models.userGoalSettings.sync_individual(goal_id).then(() => {
      log2('User Goal attached!', goal_id);

      // store.commit("goal/GOAL_USERDATA_ATTACHED", goal_id);
      store.commit("goal/INCREASE_UPDATE_COUNT");
    });
    */

    // TODO: This would be a good time to fix the cachedName if goalMeta.name is
    // not the same as userGoalSettings.cachedName
    return {
      promiseGoalMeta: p1,
      promiseCommitments: p2,
      promiseRecordedSessions: p3,
    }
  },

  // ---------------------------------------------------------------------------
  /*
   * This is called as soon as the goals have been loaded
   */
  goalListReady(new_goal_list, old_goal_list) {

    if ( !new_goal_list || new_goal_list.length === 0) {
      /* This is also the case when no goal is loaded */
      log2("Goal list is empty -> return ")
      return;
    }

    let at_least_one_goal_loaded = false;
    let num_of_active_goals_last_update = num_of_active_goals_while_updateting;
    num_of_active_goals_while_updateting = 0;

    new_goal_list.map((goal_id) => {
      let ready = store.getters['goal/goal_is_ready'](goal_id); // TODO
      at_least_one_goal_loaded = at_least_one_goal_loaded || ready;
      num_of_active_goals_while_updateting += ready ? 1 : 0;
      log2("[DEBUG]", goal_id, " => ", ready)
    });

    if ( !at_least_one_goal_loaded ) {
      log2("No active goal yet -> return")
      return;
    } else {
      log2("at least one active goal")
    }

    if ( JSON.stringify(new_goal_list) ===
         JSON.stringify(old_goal_list) &&
         num_of_active_goals_last_update ===
         num_of_active_goals_while_updateting ) {
      log2("Goal List not changed -> return")
      // console.table(new_goal_list)
    } else {
      log2("Goal List changed. Attaching contacts...");
    }
  },

  // ---------------------------------------------------------------------------
  /*
   * Dettaches alls goals
   */
  dettachAllGoals() {

    let goal_list_with_ids = [] // TODO

    if ( goal_list_with_ids ) {
      goal_list_with_ids.forEach((id) => {
        this.dettachGoal(id)
      })
    }
  },

  // ---------------------------------------------------------------------------
  /*
   * Dettaches one goal
   */
  dettachGoal( goal_id ) {
    log2("Detaching goal", goal_id);

    // TODO: Check what happens at logout, what clean up is needed here?

    $models.goalMeta.unsync( goal_id )
    // TODO: Also unsync everything else under /goals/id/*

    /* Remove ready flag entirly */
    rem_ready( 'goal:' + goal_id );
    // sem_ready( 'goal:' + goal_id, false );
    // TODO: redirect
    if ( router.currentRoute.path.includes( goal_id ) ) {
      console.log("CURRENTLY ON A ROUTE WITH GOAL ID -> redirect")
      router.push('/goals') // TODO
    }

    /*
    if ( goal_id in devGlobalGoalReference ) {
      delete devGlobalGoalReference[goal_id];
    }
    if ( goal_id in devGlobalUserGoalReference ) {
      delete devGlobalUserGoalReference[goal_id];
    }
    */
  }
}

export default ResourceLoader;
